module.exports = __webpack_public_path__ + "static/media/spinner.2cbba806.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/spinner.svg
// module id = 85
// module chunks = 0